import { render, staticRenderFns } from "./worldMap.vue?vue&type=template&id=43b09f2c&scoped=true&"
import script from "./worldMap.vue?vue&type=script&lang=js&"
export * from "./worldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b09f2c",
  null
  
)

export default component.exports